// containers/Communications/Communications.js
import React, {PureComponent} from 'react';

import axios from "../../axios-defaults";
import { withTranslation } from 'react-i18next';
import TableContainer from '../../components/Communications/Table/TableContainer';
import PageTitle from "../../components/Commons/PageTitle";
import DateFormated from "../../components/Utils/Date/Date";
import Auxiliary from "../../hoc/Auxiliary";
import Spinner from "../../components/UI/Spinner";
import SelectWrapper from "../../components/Utils/Input/SelectWrapper";
import SearchForm from "../../components/UI/SearchForm/SearchForm";
import Sorter from "../../components/UI/Toolbar/Sorter";
import DateFilters, {
    DEFAULT_DATE,
    TODAY,
    TODAY_MINUS_14,
    TODAY_MINUS_30,
    DEFAULT_FILTER_ALL_PAGE_NUMBER,
    DEFAULT_FILTER_ALL_PAGE_SIZE
} from "../../components/Accounts/Account/Tables/DateFilters"
import DatePicker from "react-datepicker";
import formatDate from "../../components/Utils/Date/formatDate";
import {fireGTMDownloadFileEvent} from "../../components/Utils/GTM/GTMHelper";
import TextTruncate from "../../components/UI/TextTruncate";

/*
* TABLE DOCS : https://thewidlarzgroup.com/react-table-7
* */

class Communications extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            originalData: [],
            communications: [],
            accountTypes: [],
            communicationsTypes: [],
            documents_status: [],
            sortField: 'date',
            sortDirection: 'DESC',
            pageIndex: 0,
            filters: { accountType: '', communicationType: '', unreadOnly: false},
            startDate: null,
            endDate: null,
            pageNumber: DEFAULT_FILTER_ALL_PAGE_NUMBER,
            pageSize: DEFAULT_FILTER_ALL_PAGE_SIZE,
            isSpecific : false,
            dateFilterType :'last_all',
            noData : false,
        }
    }

    componentDidMount(){
        this.getDocumentStatus();
        this.getCommunications();
    }

    getCommunications = () => {
        let params = '';

        if (this.state.pageNumber && this.state.pageSize) {
            params = `pageNumber=${this.state.pageNumber}&pageSize=${this.state.pageSize}`
            this.setState({loading:true});
        } else {
            if(this.state.startDate === null || this.state.endDate === null){
                return null;
            }else{
                params = `startDate=${this.state.startDate}&endDate=${this.state.endDate}`
                this.setState({loading:true});
            }
        }

        let urlToGet = `/accounts/communications?${params}`;
        axios.get(urlToGet)
            .then(response => {

                if(response.data.succeeded){
                    let communicationsArray = [];
                    if(Array.isArray(response.data.data) && response.data.data.length > 0){
                        this.setState({noData:false});
                        response.data.data.map((item) => {
                            const docStatus = this.state.documents_status.find((data) => {
                                return data['document_path'] == item.documentPath;
                            })
                            communicationsArray.push({
                                title: item.documentName,
								type: item.communicationType,
                                accountName: {name:item.subAccountName,code:item.subAccountCode},
                                accountType: item.subAccountType,
                                date: item.communicationDate,
                                status: !docStatus?'U':(docStatus.document_status),
                                file: item.documentPath
                            });
                        });
                    }else{
                        this.setState({noData:true});
                    }
                    this.setState({
                        originalData: communicationsArray,
                        communications : communicationsArray
                    },() => {
                        this.setState({
                            accountTypes: this.setAccountTypes(),
                            communicationsTypes: this.setCommunicationsTypes()
                        });

                        if(window.location.hash === '#letter'){
                            this.onFilterChange('L','communicationType');
                            this.setState({
                                filters: {
                                    accountType: '',
                                    communicationType: 'L',
                                    unreadOnly: false
                                }
                            });
                        }

                    });
                }
                this.setState({loading:false})
            }).catch(error => {
                this.setState({loading:false});
                console.log('[Communications.js] : Ajax error in getCommunications()',error.message)
            });
    }

    getDocumentStatus = () => {
        if(this.state.startDate === null || this.state.endDate === null){
            return null;
        }else{
            this.setState({loading:true});
        }
        axios.get(`/documents_status`)
            .then(response => {
                if (response.data.succeeded) {
                    this.setState({documents_status : response.data.data});
                }
                this.setState({loading: false});
            }).catch(error => {
                console.log('[Communication.js] : DocumentStatus ajax error in getDocumentStatus()',error.message);
                this.setState({loading: false});
            });
    }

    onClickAction = (filename) => {
        axios.get(`/documents/download?filename=${encodeURI(filename)}`)
            .then(response => {

                if (response.data.succeeded) {
                    const items = {...this.state.communications}
                    let key = 0;
                    const editItem = this.state.communications.find((item, index) => {
                        key = index;
                        return item.file == filename;
                    });
                    editItem.status = 'R';
                    items[key] = editItem
                    this.setState({
                        communications : Object.values(items)
                    });
                }
                this.setState({loading: false});
            }).catch(error => {
                console.log('[Communication.js] : DocumentStatus ajax error in getDocumentStatus()',error.message);
                this.setState({loading: false});
            });
        window.open(`/rest/v1/communications/download?filename=${encodeURI(filename)}`)
    }

    setAccountTypes = () => {
        let types = [];
        this.state.communications.forEach(element => {
            types.push(element.accountType);
        });

        // filter duplicates
        return [...new Map(types.map(item => [item.code, item])).values()];
    }
    setCommunicationsTypes = () => {
        let types = [];
        this.state.communications.forEach(element => {
            types.push(element.type.code);
        });

        // filter duplicates
        const typesFiltered = [...new Set(types)];

        return typesFiltered;
    }

    mapFilteredData = () => {
        const { filters, communications } = this.state;

       let filteredData = communications.filter(item => {
            // loop through active filters and check if the current item match them
            let isMatching = true;
            Object.entries(filters).forEach(entry  => {
                const [key, value] = entry;
                if(value){
                    switch(key){
                        case 'accountType':
                            isMatching = item.accountType.code === filters.accountType && isMatching;
                            break;
                        case 'communicationType':
                            isMatching = item.type.code === filters.communicationType && isMatching;
                            break;
                        case 'unreadOnly':
                            isMatching = item.status !== 'R' && isMatching;
                            break;
                        default: isMatching = true;
                    }
                }
            });
            // return result of our match algorithm
            return isMatching;
        });
        return filteredData;
    }

    onFilterChange = (value, filter) => {
        if(!filter) return null;

        this.setState({
            filters: {...this.state.filters,[filter] : value }
        });

    };

    resetFiltersHandler = () => {
        this.setState({
            filters: {
                accountType: '',
                communicationType: '',
                unreadOnly: false
            }
        });
    }

    onSearchDataUpdate = (searchData) => {
        //this.resetFiltersHandler();

        if(Array.isArray(searchData)){
            return this.setState({communications:searchData});
        } else{ return null; }
    }

    handleSort = (sortBy) => {
        if (sortBy.length > 0) {
            this.setState({sortField: sortBy[0].id, sortDirection: sortBy[0].desc?'DESC':'ASC'});
        }
    }

    handlePage = (pageIndex) => {
        this.state.pageIndex = pageIndex;
    }

    storeSortedItems = (items) => {
        this.setState({communications: items});
    }

    setSorterCallback = (columnId, direction) => {
        this.setState({sortField: columnId, sortDirection: direction});
    }

    objectCommunicationTypeSort = (rowA, rowB, columnId) => {
        let titleAccessor = 'descriptionEn';
        if (this.props.i18n.language === 'fr') {
            titleAccessor = 'descriptionFr';
        }
        const a = rowA.values[columnId][titleAccessor];
        const b = rowB.values[columnId][titleAccessor];
        return a > b ? 1 : -1;
    }

    objectAccountCodeSort = (rowA, rowB, columnId) => {
        const codeA = rowA.values[columnId].code !== ''?rowA.values[columnId].code:0;
        const codeB = rowB.values[columnId].code !== ''?rowB.values[columnId].code:0;
        const a = parseInt(codeA);
        const b = parseInt(codeB);
        return a > b ? 1 : -1;
    }

    /* START DATEFILTERS FUNCTIONS */
    setStartDate = (date) => {
        if (date != null) {
            const dateFormatted = `${date.toISOString().split("T")[0]}T00:00:00.000Z`;
            this.setState({startDate: dateFormatted},()=>{
                this.getDocumentStatus();
                this.getCommunications();
            });
        }
    }
    setEndDate = (date) => {
        if(date != null){
            const dateFormatted = `${date.toISOString().split("T")[0]}T23:59:59.999Z`;
            this.setState({endDate: dateFormatted},()=>{
                this.getDocumentStatus();
                this.getCommunications();
            });

        }
    }
    setLastAll = (refresh = true, component = null) => {
        this.setState({
            startDate: false,
            endDate: false,
            pageNumber: DEFAULT_FILTER_ALL_PAGE_NUMBER,
            pageSize: DEFAULT_FILTER_ALL_PAGE_SIZE,
            isSpecific: false
        },()=>{
            this.getDocumentStatus();
            this.getCommunications();
        });
    }
    setLast14Days = (refresh = true, component = null) => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_14)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: null,
            pageSize: null,
            isSpecific: false
        },()=>{
            this.getDocumentStatus();
            this.getCommunications();
        });
    }
    setLast30Days = () => {
        this.setState({
            startDate: formatDate(new Date(TODAY_MINUS_30)),
            endDate: formatDate(TODAY,'23:59:59.999Z'),
            pageNumber: null,
            pageSize: null,
            isSpecific: false
        },()=>{
            this.getDocumentStatus();
            this.getCommunications();
        });
    }
    setSpecificDate = () => {
        this.setState({
            startDate: null,
            endDate: null,
            pageNumber: null,
            pageSize: null,
            isSpecific: true
        });
    }
    setDateFilterType = (type) => {
        this.setState({ dateFilterType: type });
        switch (type) {
            case 'last_all': this.setLastAll(); break;
            case 'last_14': this.setLast14Days(); break;
            case 'last_30': this.setLast30Days(); break;
            case 'specific_date': this.setSpecificDate(); break;
            default: this.setLastAll();
        }
    }

/* END DATEFILTERS FUNCTIONS */



    render(){
        const { originalData,
            communications,
            communicationsTypes,
            loading,
            accountTypes,
            filters } = this.state;

        let renderedData = this.mapFilteredData();

        const columns = [
                {
                    Header: this.props.t('communications.table.headers.subject'),
                    accessor: 'title',
                    //sortType: this.objectCommunicationTypeSort,
                    Cell: (props) => {
						return props.value ? (
							<strong>
								<TextTruncate length={40} multiline={2}>
									{ props.value }
								</TextTruncate>
							</strong>
						) : '';
                    },
                },
                {
                    Header: this.props.t('communications.table.headers.account'),
                    accessor: 'accountName',
                    sortType: this.objectAccountCodeSort,
                    Cell: (props) => {
                        let html = (
                            <Auxiliary>
                                {(props.value.name) && <Auxiliary><strong>{props.value.name}</strong><br/></Auxiliary>}
                                {(props.value.code) && <small>#{props.value.code}</small>}
                            </Auxiliary>
                        );
                        return html;
                    }
                },
                {
                    Header: this.props.t('communications.table.headers.document'),
                    accessor: 'type',
                    sortType: this.objectCommunicationTypeSort,
                    Cell: (props) => {
                        let descriptionAccessor = 'descriptionEn';
                        if(this.props.i18n.language === 'fr') descriptionAccessor = 'descriptionFr';
                        return props.value[descriptionAccessor] ? (
							<>
								<strong className="d-block">{props.value[descriptionAccessor]}</strong>
								{
									(props.row.original.accountType[descriptionAccessor]) && (
										<small className="d-block">
											{props.row.original.accountType[descriptionAccessor]}
										</small>
									)
								}
							</>
						) : '';
                    },
                },
                {
                    id: 'date',
					Header: this.props.t('communications.table.headers.senton'),
                    accessor: 'date',
                    sort: 'desc',
                    Cell: (props) => {
                        return props.value ? <DateFormated date={props.value} withTime={true} /> : '';
                    },
                    sortMethod: (a, b) => {
                        var a1 = new Date(a).getTime();
                        var b1 = new Date(b).getTime();
                        if (a1 < b1)
                            return 1;
                        else if (a1 > b1)
                            return -1;
                        else
                            return 0;
                    }
                },
                {
                    Header: this.props.t('communications.table.headers.status'),
                    accessor: 'status',
                    Cell: ({cell}) => {
                        const {value} = cell;
                        const pickStatus = (value) => {
                            let status = '';
                            if (value == 'R') {
                                status = (
                                    <div className="status status--black" style={{minWidth:"78px"}}>
                                        <i className="fas fa-eye"></i>&nbsp;{this.props.t('communications.table.read')}
                                    </div>
                                );
                            } else {
                                status = (
                                    <div className="status status--red" style={{minWidth:"78px"}}>
                                        <i className="fas fa-eye-slash"></i>&nbsp;{this.props.t('communications.table.unread')}
                                    </div>
                                );
                            }
                            return status;
                        };
                        return (<div>{pickStatus(value)}</div>);
                    }
                },
                {
                    Header: () => null,
                    id: 'file', // 'id' is required
                    accessor: 'file',
                    Cell: (props) => {
                        if(props.value){
                            return (
                                <a href="#"
                                   onClick={(e) => {
                                       e.preventDefault();
                                       this.onClickAction(props.value)
									   if(props.row.original.type.code === "F"){
										   fireGTMDownloadFileEvent('facture', 'PDF')
									   }else if(props.row.original.type.code === "R"){
										   fireGTMDownloadFileEvent('releve', 'PDF')
									   }else if(props.row.original.type.code === "L"){
										   fireGTMDownloadFileEvent('priceletter', 'PDF')
                                   		}else if(props.row.original.type.code === "E"){
										   fireGTMDownloadFileEvent('cashing', 'PDF')
									   }else if(props.row.original.type.code === "P"){
										   fireGTMDownloadFileEvent('delproof', 'PDF')
									   }
								   }}
                                   className="link link--red link--upper link--accent link--fs-14 d-inline-block">
                                    <strong>{this.props.t('communications.table.downloadpdf')}&nbsp;&nbsp;<i className="fas fa-angle-right"></i></strong>
                                </a>
                            );
                        } else { return ''; }
                    }

                },
            ];

        let tableContent = <Spinner />;
        if (originalData.length > 0 && !loading) {
            if(originalData.length > 0){
                tableContent = (
                    <Auxiliary>
                        <div className="datatable__filters flex flex-column  flex-md-row flex--wrap flex--justify-start align-start align-sm-center">
                            <div className="datatable__filters__group w-100 flex flex-column flex-sm-row flex--wrap flex--justify-start align-items-sm-center align-items-start">
                                <strong className="mb-1 mb-sm-0">{this.props.t('misc.filter')}&nbsp;&nbsp;</strong>
                                <div className="mb-2 mb-sm-0 mr-0 mr-sm-4 selectcontainer">
                                    <SelectWrapper>
                                        <select id="account-filters"
                                            onChange={(e) => {
                                                let selectValue = e.target.value;
                                                this.onFilterChange(selectValue,'accountType');
                                            }}
                                            value={filters.accountType}
                                        >
                                            <option value="">{this.props.t('misc.account_type')}</option>
                                            {accountTypes.map(type => {
                                                if(type.code){
                                                    return (<option value={type.code} key={type.code}>{this.props.t('misc.account_types.'+type.code)}</option>);
                                                } else {
                                                    return '';
                                                }
                                            })}
                                        </select>
                                    </SelectWrapper>
                                </div>
                                <div className="mb-2 mb-sm-0 mr-0 mr-sm-4 selectcontainer">
                                    <SelectWrapper>
                                        <select id="documenttype-filters"
                                            onChange={(e) => {
                                                let selectValue = e.target.value;
                                                this.onFilterChange(selectValue,'communicationType');
                                            }}
                                            value={filters.communicationType}
                                        >
                                            <option value="">{this.props.t('misc.communication_type')}</option>
                                            {communicationsTypes.map(type => {
                                                if(type){
                                                    return (<option value={type} key={type}>{this.props.t('misc.communication_types.'+type)}</option>);
                                                } else { return ''; }
                                            })}
                                        </select>
                                    </SelectWrapper>
                                </div>
                            </div>

                            <label className="checkbox-field checkbox-field--gray mr-auto mt-3 mt-md-0 flex align-self-center" htmlFor="unread_only">
                                <input type="checkbox" name="unread_only" id="unread_only" checked={this.state.filters.unreadOnly} onChange={(e) => this.onFilterChange(e.target.checked,'unreadOnly')} />
                                <span></span>
                                    <strong>&nbsp;&nbsp;{this.props.t('communications.filters_groups.unread.label')}</strong>
                            </label>
                            <div className="filters__right">
                                <Sorter
                                    sortOptions={[
                                        {
                                            label: this.props.t('communications.table.headers.subject'),
                                            id: 'title',
                                            value: 'title',
                                            type: 'string'
                                        },{
                                            label: this.props.t('communications.table.headers.account'),
                                            id: 'accountName',
                                            value: 'accountName.code',
                                            type: 'string'
                                        },{
                                            label: this.props.t('communications.table.headers.document'),
                                            id: 'type',
                                            value: (this.props.i18n.language === 'fr') ? 'type.descriptionFr' : 'type.descriptionEn',
                                            type: 'string'
                                        },{
                                            label: this.props.t('communications.table.headers.senton'),
                                            id: 'date',
                                            value: 'date',
                                            type: 'date'
                                        },{
                                            label: this.props.t('communications.table.headers.status'),
                                            id: 'status',
                                            value: 'status',
                                            type: 'string'
                                        }
                                    ]}
                                    items={renderedData}
                                    getSortedItems={this.storeSortedItems}
                                    setSortByCallback={this.setSorterCallback}
                                    sortDirection={this.state.sortDirection}
                                    sortField={this.state.sortField}
                                    currentDisplayMode={'list'}
                                />
                            </div>
                        </div>
                        <TableContainer
                            columns={columns}
                            data={renderedData}
                            onSort={this.handleSort}
                            onPage={this.handlePage}
                            initialStateField={this.state.sortField}
                            initialStateDirection={this.state.sortDirection}
                            initialPageIndex={this.state.pageIndex}
                            currentFilters={this.state.filters}
                        />
                    </Auxiliary>
                );
            } else {
                if(loading){
                    tableContent = <Spinner />
                } else {
                    tableContent = (<p><strong>{this.props.t('communications.noresults')}</strong></p>);
                }
            }
        }else if(this.state.noData && !loading){
            tableContent = (<p><strong>{this.props.t('communications.noresults')}</strong></p>);
        }

        return (
            <div className="container container--larger communications">
                <PageTitle title={this.props.t('communications.title')} />
                <br />
                <div className='section__action section__action--comms'>
                    <SearchForm data={originalData} updateData={this.onSearchDataUpdate} />
                    <a href={this.props.t('footer.need_help_link')} className='btn btn--outline'>{this.props.t('communications.contactourteam')}</a>
                </div>
                <div className="mt-3 mt-sm-2 mb-2">
                    <DateFilters
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        setStartDate={this.setStartDate}
                        setEndDate={this.setEndDate}
                        changeDateFilterType={this.setDateFilterType}
                        dateFilterType={this.state.dateFilterType}
                        enableCurrentPeriod={false}
                        component={null}
                        labelFilterAll={this.props.t("docs.invoices.table.filter.all.documents")}
                    />
                </div>
                {tableContent}
            </div>
        );

    }
}

export default withTranslation()(Communications);
